import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreSonarTaskConfigsByOrganizationIdAndTaskTypeGetAsyncSlice } from './get';
import { coreSonarTaskConfigsByOrganizationIdAndTaskTypePatchAsyncSlice } from './patch';

export const coreSonarTaskConfigsByOrganizationIdAndTaskTypeReducers = combineReducers({
	get: coreSonarTaskConfigsByOrganizationIdAndTaskTypeGetAsyncSlice.asyncReducers,
	patch: coreSonarTaskConfigsByOrganizationIdAndTaskTypePatchAsyncSlice.asyncReducers
});

export const coreSonarTaskConfigsByOrganizationIdAndTaskTypeWatchers = combineAllWatchers([
	coreSonarTaskConfigsByOrganizationIdAndTaskTypeGetAsyncSlice.asyncWatchers,
	coreSonarTaskConfigsByOrganizationIdAndTaskTypePatchAsyncSlice.asyncWatchers
]);
